export default __webpack_public_path__ + "static/media/youtube.3ade6fde.svg";